<template lang="pug">
Viewer(:book="book" :intro="false")
  .book-chapter
    .book-chapter-content
      Content
        div(v-html="book.chapter.node.body")
    div(v-if="book.chapter.next")

      .bookNext.u-mh-md
        h2.u-mb-xm(v-html="$t('nextChapter')")
        AppCard( :title="book.chapter.next.title" :img="book.chapter.next.thumb" :url="`/books/${book.slug}/${book.chapter.next.slug}`" ratio="2:1" :meta="`${$t('chapter')}: ${book.chapter.index + 2 }`")

  .u-mt-md(v-if="book.chapter.isLast")
    AppTitle.u-mb-xs(tag="h2" :title="$t('moreBooks')")
    Query.grid.is-labs.is-desktop-4.is-tablet-6(
      :query="require('~/graphql/Book.gql').Books"
      :limit="limit"
      :variables="({ first, after }) => ({ first, after, excluded: [book.id] })"
      @fetch="limit = 6"
      :refetchOnRouteChange="true"
    )
      template(slot-scope="{ items }")
        .column(v-for="book in items" :key="book.id")
          AppCard(:img="book.thumb" :title="book.title" :url="`/books/${book.slug}`" ratio="4:5")

</template>

<script>
import Content from '../Content';
import Viewer from './index';

export default {
  name: 'ChapterView',
  components: {
    Content,
    Viewer,
    Query: () => import('../Query.vue'),
    AsymetricGrid: () => import('../PsudoRandomGrid.vue')
  },
  props: {
    book: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    chapters: [],
    showNav: false,
    limit: 3
  }),
  computed: {
    orderedChapters() {
      return [...this.chapters].sort((a, b) => {
        return a.index - b.index;
      });
    }
  },
  methods: {
    showTableOfContents() {
      this.showNav = true;
    }
  }
};
</script>

<i18n>
{
  "en": {
    "moreBooks":"More |Books",
    "nextChapter":"Next <br> Chapter:",
    "chapter":"Chapter"
  },
  "ar": {
    "moreBooks":"المزيد",
    "nextChapter":"الفصل  <br> التالي",
    "chapter":"فصل"

  }
}
</i18n>

<style lang="stylus">
.bookNav.is-centered
  justify-content: center

.bookNext
  max-width: 1000px
  margin-right: auto
  margin-left: auto
</style>
